<form [formGroup]="form" class="cipx-form-section activity-call-form">
  <div class="cipx-form-form-group activity-call-form-fields">
    <mat-form-field appearance="fill" class="activity-call-form-field">
      <mat-label>On Call</mat-label>
      <mat-chip-grid #actorChipGrid aria-label="Selected call actors">
        @for (actor of selectedActors; track actor.actor_scope_key + ':' + actor.actor_id) {
          <mat-chip-row (removed)="removeActor(actor)">
            {{ actor.actor_full_name }}
            <button matChipRemove [attr.aria-label]="'remove ' + actor.actor_full_name">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          #actorInput
          placeholder="Search account users or admins"
          [matChipInputFor]="actorChipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matAutocomplete]="actorAuto"
          (matChipInputTokenEnd)="addActorFromInput($event)"
          (input)="onActorQueryChange(actorInput.value)"
          (focus)="onActorQueryChange(actorInput.value)" />
      </mat-chip-grid>
      <mat-autocomplete #actorAuto="matAutocomplete" (optionSelected)="addActorFromAutocomplete($event)">
        @if (filteredActors.length === 0) {
          <mat-option disabled>Nobody found</mat-option>
        }
        @for (actor of filteredActors; track actor.actor_scope_key + ':' + actor.actor_id) {
          <mat-option [value]="actor">
            <div class="activity-call-actor-option">
              <span class="activity-call-actor-name">{{ actor.actor_full_name }}</span>
              <span class="activity-call-actor-scope">({{ getActorScopeLabel(actor) }})</span>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <div class="activity-call-type-section">
      <label class="cipx-form-label activity-call-type-label">Call Type</label>
      <mat-button-toggle-group formControlName="eventTypeId" class="activity-call-type-toggle-group">
        @for (callType of callTypeOptions; track callType) {
          <mat-button-toggle [value]="callType">
            {{ callTypeLabelMap[callType] }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>

    <mat-form-field appearance="fill" class="activity-call-form-field">
      <mat-label>Related Requests</mat-label>
      <mat-chip-grid #relatedRequestChipGrid aria-label="Related quote requests">
        @for (item of selectedRelatedRequests; track item.quote_request_id) {
          <mat-chip-row (removed)="removeRelatedRequest(item)">
            {{ item.order_number || item.quote_request_id }}
            <button matChipRemove [attr.aria-label]="'remove request ' + item.quote_request_id">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          #relatedRequestInput
          placeholder="Search order # or quote request id"
          [matChipInputFor]="relatedRequestChipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matAutocomplete]="relatedAuto"
          (matChipInputTokenEnd)="addRelatedRequestFromInput($event)"
          (input)="onRelatedQueryChange(relatedRequestInput.value)"
          (focus)="onRelatedQueryChange(relatedRequestInput.value)" />
      </mat-chip-grid>
      <mat-autocomplete #relatedAuto="matAutocomplete" (optionSelected)="addRelatedRequestFromAutocomplete($event)">
        @if (filteredRelatedRequests.length === 0) {
          <mat-option disabled>No related requests found</mat-option>
        }
        @for (item of filteredRelatedRequests; track item.quote_request_id) {
          <mat-option [value]="item">
            <div class="activity-call-related-option">
              <span class="activity-call-related-order">
                {{ item.order_number || item.quote_request_id }}
              </span>
              <div class="activity-call-related-summary">
                <div class="activity-call-related-company">
                  {{ item.company_name || item.label || 'Quote Request ' + item.quote_request_id }}
                </div>
                <div class="activity-call-related-bond">{{ item.surety_bond_label }}</div>
              </div>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="fill" class="activity-call-form-field">
      <mat-label>Subject</mat-label>
      <input matInput type="text" formControlName="subject" placeholder="What happened on this call?" />
      @if (form.controls.subject.hasError('required')) {
        <mat-error>Subject is required</mat-error>
      }
    </mat-form-field>

    <div class="activity-call-notes">
      <mat-label>Notes</mat-label>
      <tiny-editor
        [editorOptions]="{ min_height: 200, max_height: 600, resize: true }"
        controlName="notes"
        [spellcheck]="true"
        editorType="basic"></tiny-editor>
    </div>

    <mat-checkbox formControlName="createFollowUpTask" class="activity-call-follow-up-toggle">
      Create follow up task
    </mat-checkbox>
  </div>
</form>
